const state = {
    model: {
        welcome: {
          title: "",
          text: "",
          is_automatic: ""
        },
        date_assembly: {
          title: "",
          text: "",
          is_automatic: ""
        },
        birth_date: {
          title: "",
          text: "",
          is_automatic: ""
        },
        after_sales: {
          title: "",
          text: ""
        },
        per_installments: [],
        client_follow_up: 30,
        max_installment_to_download: 12,
        condensed_analytical_commission_by_profile_report: false,
        display_supervisor_summary_on_analytical_commission_by_profile_report: false,
        display_commissions_totals_only_on_analytical_commission_by_profile_report: false,
        analytical_commission_by_profile_report_alternate_layout: false,
        print_empty_sales_on_analytical_commission_by_profile_report: false,
      },
};

export default state;